import { Image } from 'expo-image';
import Ionicons from '@expo/vector-icons/Ionicons';
import { Pressable, Text, View } from 'react-native';
import type { User } from '@/types/user';
import { imageUrl } from '@/utils/image-url';

interface UserResultItemProps {
  user: User;
  onPress: (identifier: string) => void;
}

export function UserResultItem({ user, onPress }: UserResultItemProps) {
  const username = user.username || user.displayUsername || '';
  const normalizedUsername = username.replace(/^@+/, '');
  const displayUsername = normalizedUsername ? `@${normalizedUsername}` : '';
  const userAvatar = imageUrl(user.image || user.avatar, 'thumbnail');

  return (
    <Pressable
      onPress={() => onPress(normalizedUsername || user.id)}
      className="mb-4 p-4 rounded-lg flex-row items-center bg-surface border border-border"
      style={{ borderCurve: 'continuous' }}
    >
      {userAvatar ? (
        <Image
          source={{ uri: userAvatar }}
          className="w-16 h-16 rounded-full mr-3 bg-surface-secondary"
          accessibilityLabel={`${user.name || 'Unknown User'}'s profile photo`}
        />
      ) : (
        <View className="w-16 h-16 rounded-full mr-3 items-center justify-center bg-surface-secondary">
          <Ionicons name="person" size={32} className="text-muted-foreground" />
        </View>
      )}

      <View className="flex-1">
        <Text className="text-lg font-semibold mb-1 text-foreground">
          {user.name || 'Unknown User'}
        </Text>
        {displayUsername && (
          <Text className="text-sm text-muted-foreground">
            {displayUsername}
          </Text>
        )}
        {user.bio && (
          <Text className="text-sm mt-1 text-muted-foreground" numberOfLines={2}>
            {user.bio}
          </Text>
        )}
      </View>
    </Pressable>
  );
}
